import {
  type PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react';
import {type CompanyRegistrationMasterResponse} from '@openapi/company-registration-form';
import {getMasterData} from '@/features/company-registration/api/operations/get-master';

const MasterDataContext =
  createContext<CompanyRegistrationMasterResponse | null>(null);

export const useMasterData = () => {
  return useContext(MasterDataContext);
};

export function MasterDataProvider({children}: PropsWithChildren) {
  const [data, setData] = useState<CompanyRegistrationMasterResponse | null>(
    null,
  );

  useEffect(() => {
    const abortController = new AbortController();

    const fetchData = async () => {
      const data = await getMasterData({
        signal: abortController.signal,
      });
      setData(data);
    };

    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- useEffectにasync関数を渡せないため
    fetchData();

    return () => {
      abortController.abort();
    };
  }, []);

  return (
    <MasterDataContext.Provider value={data}>
      {children}
    </MasterDataContext.Provider>
  );
}
